module.exports = __webpack_public_path__ + "static/01-fireworks-e9578a6ed165c74173b0eb05b4f5afa6.jpg";